import React, { useState } from "react";
import { FaLinkedin, FaEnvelope } from "react-icons/fa";
import "./Team.css";

const Team = () => {
  const [activeTab, setActiveTab] = useState("excom");

  const excomMembers = [
    {
      id: 1,
      name: "Tharushi De Silva",
      title: "Chairperson",
      image: "/assets/excom2026/CP2026.jpeg",
      linkedin: "https://www.linkedin.com/in/vishwani-bhagya",
      email: "bhagyalgv@gmail.com",
    },
    {
      id: 2,
      name: "Thavishi Weerasinghe",
      title: "Vice Chairperson",
      image: "/assets/excom2026/VCP2026.jpeg",
      linkedin: "https://www.linkedin.com/in/ritharak",
      email: "ritharaedirisinghe@gmail.com",
    },
    {
      id: 3,
      name: "Maheshi Saranga",
      title: "Secretary",
      image: "/assets/excom2026/S2026.jpeg",
      linkedin: "https://www.linkedin.com/in/nilupulee-amarathunga-637710222",
      email: "nilupulee2001@gmail.com@ieee.lk",
    },
    {
      id: 4,
      name: "Sanali Wimalarathne",
      title: "Treasurer",
      image: "/assets/excom2026/T2026.jpeg",
      linkedin: "http://linkedin.com/in/poojathmi-deepna",
      email: "poojathmideepna@gmail.com",
    },
    {
      id: 5,
      name: "Tharushi Bhagya",
      title: "Assistant Secretary",
      image: "/assets/excom2026/AS2026.jpeg",
      linkedin: "https://www.linkedin.com/in/sanuji-samarakoon-81a45a294",
      email: "academic@sanujis1102@gmail.com.lk",
    },
    {
      id: 6,
      name: "Kaveesha Kalhari",
      title: "Chief Organizer",
      image: "/assets/excom2026/CO2026.jpeg",
      linkedin: "https://www.linkedin.com/in/lahiruni-malshika-234242222",
      email: "lahimalshi@gmail.com",
    },
    {
      id: 7,
      name: "Erandathee Wijeratne",
      title: "Web Master",
      image: "/assets/excom2026/WM2026.jpeg",
      linkedin: "https://www.linkedin.com/in/lahiruni-malshika-234242222",
      email: "lahimalshi@gmail.com",
    },
  ];

  const bodMembers = [
    {
      id: 1,
      name: "Maheshi Saranga",
      title: "Director of Membership Development and Volunteer Coordination",
      image: "/assets/directors/Director1.png",
      linkedin: "http://www.linkedin.com/in/maheshi-saranga",
      email: "sarangahettiarachchige@gmail.com",
    },
    {
      id: 2,
      name: "Thavishi Minolka",
      title: "Director of Design and Publicity",
      image: "/assets/directors/Director2.png",
      linkedin: "https://www.linkedin.com/in/thavishi-weerasinghe-205bbb264",
      email: "thavishiminolka@gmail.com",
    },
    {
      id: 3,
      name: "Kaveesha Kalhari",
      title: "Director of Program and Event Coordination",
      image: "/assets/directors/Director3.png",
      linkedin: "https://www.linkedin.com/in/kaveesha-kalhari",
      github: "#",
      email: "kaveeshahansani2003@gmail.com",
    },
  ];

  const committeeLeads = [
    {
      id: 1,
      name: "Charuka Vithana ",
      title: "Design Lead",
      image: "/assets/leads/CL1.png",
      linkedin: "https://www.linkedin.com/in/charuka-vithana-87467a277",
      email: "clvithana2001@gmail.com",
    },
    {
      id: 2,
      name: "Dinithi Wijesekara ",
      title: "Editorial Lead",
      image: "/assets/leads/CL4.png",
      linkedin: "https://www.linkedin.com/in/dinithi-wijesekara",
      email: "dinithiwijesekara025@gmail.com",
    },
    {
      id: 3,
      name: "Sanali  Wimalarathne",
      title: "Marketing Lead",
      image: "/assets/leads/CL3.png",
      linkedin: "http://www.linkedin.com/in/sanali-wimalarathne-0247691b0",
      email: "sanaliwimalarathne@gmail.com",
    },
    {
      id: 4,
      name: "Pubudini Gayasha",
      title: "Media Lead",
      image: "/assets/leads/CL2.png",
      linkedin: "https://www.linkedin.com/in/pubudini-gayasha",
      email: "gayashauni@gmail.com",
    },
    {
      id: 5,
      name: "Dulmini Abeyweera",
      title: "Finance Lead",
      image: "/assets/finance/FC5.png",
      linkedin: "http://www.linkedin.com/in/dulmini-abeyweera",
      email: "dulminiabeyweera688@gmail.com",
    },
  ];

  const committeeMembers = [
    {
      id: 1,
      name: "Tharushi De Silva",
      title: "Design Team Member",
      image: "/assets/design/DC1.png",
      linkedin: "https://www.linkedin.com/in/tharushii",
      email: "desilva.tharushiw@gmail.com",
    },
    {
      id: 2,
      name: "Sandali Sathsarani",
      title: "Design Team Member",
      image: "/assets/design/DC2.png",
      linkedin: "https://www.linkedin.com/in/sandali-sathsarani-732199287",
      email: "sandalialuthgamage22@gmail.com",
    },
    {
      id: 3,
      name: "Renulucshmi Prakasan ",
      title: "Design Team Member",
      image: "/assets/design/DC3.png",
      linkedin: "https://www.linkedin.com/in/renulucshmi",
      email: "renulucshmip@gmail.com",
    },
    {
      id: 4,
      name: "Dulithi Wijesooriya",
      title: "Design Team Member",
      image: "/assets/design/DC4.png",
      linkedin: "http://www.linkedin.com/in/dulithi-wijesooriya-6677b9254",
      email: "dulithihasa@gmail.com",
    },
    {
      id: 5,
      name: "Sanidi Sisara ",
      title: "Editiorial Team Member",
      image: "/assets/editorial/EC1.png",
      linkedin: "https://www.linkedin.com/in/sanidi-sisara",
      email: "sanidi1113@gmail.com",
    },
    {
      id: 6,
      name: "Thilinika Evanthi",
      title: "Editiorial Team Member",
      image: "/assets/editorial/EC4.png",
      linkedin: "https://www.linkedin.com/in/thilinika-evanthi-wadanambi",
      email: "evanthithilinika@gmail.com",
    },
    {
      id: 7,
      name: "Piyumi  Imasha",
      title: "Editiorial Team Member",
      image: "/assets/editorial/EC2.png",
      linkedin: "https://www.linkedin.com/in/piyumi-imasha-39a85a293",
      email: "piyumiimasha9@gmail.com",
    },
    {
      id: 8,
      name: "Sohanee Jayasundara",
      title: "Editiorial Team Member",
      image: "/assets/editorial/EC3.png",
      linkedin: "",
      email: "sohanee@gmail.com",
    },
    {
      id: 9,
      name: "Tharushi Bhagya",
      title: "Marketing Team Member",
      image: "/assets/marketing/Marketing1.png",
      linkedin: "https://www.linkedin.com/in/tharushi-bhagya",
      email: "tharubhagya18@gmail.com",
    },
    {
      id: 10,
      name: "Sandini Fernando",
      title: "Marketing Team Member",
      image: "/assets/marketing/Marketing2.png",
      linkedin: "http://www.linkedin.com/in/sandini-fernando-a64778246",
      email: "nethmafernando400@gmail.com",
    },
    {
      id: 11,
      name: "Swetha Nethmi",
      title: "Marketing Team Member",
      image: "/assets/marketing/Marketing3.png",
      linkedin: "http://www.linkedin.com/in/swetha-nethmi",
      email: "swethane28@gmail.com",
    },
    {
      id: 12,
      name: "Shiny Fernando",
      title: "Finance Team Member",
      image: "/assets/finance/FC2.png",
      linkedin: "https://www.linkedin.com/in/shiny-fernando-7367b0282",
      email: "shinyfernando719@gmail.com",
    },
    {
      id: 13,
      name: "Chalani Fernando",
      title: "Finance Team Member",
      image: "/assets/finance/FC1.png",
      linkedin: "https://www.linkedin.com/in/chalani-fernando-795996234",
      email: "chalanifdo721@gmail.com",
    },
    {
      id: 14,
      name: "Tharushi Dinushika",
      title: "Finance Team Member",
      image: "/assets/finance/FC3.png",
      linkedin: "http://www.linkedin.com/in/tharushi-dinushika-745264287",
      email: "tharushi.edinushika@gmail.com",
    },
    {
      id: 15,
      name: "Amali Perera",
      title: "Finance Team Member",
      image: "/assets/finance/FC4.png",
      linkedin: "https://www.linkedin.com/in/navodya-perera",
      email: "pereranavo20011212@gmail.com",
    },
    {
      id: 16,
      name: "Jinathi Kodikara",
      title: "Finance Team Member",
      image: "/assets/finance/FC6.png",
      linkedin: "http://www.linkedin.com/in/jinathi-kodikara-960135271",
      email: "jinathik@gmail.com",
    },
    {
      id: 17,
      name: "Dulmini Wijesinghe",
      title: "Finance Team Member",
      image: "/assets/finance/FC7.png",
      linkedin: "https://www.linkedin.com/in/dulmini-wijesinghe-12314b2a4",
      email: "hasindyawijesinghe@gmail.com",
    },
    {
      id: 18,
      name: "Rashmila Deshani",
      title: "Program Team Member",
      image: "/assets/coordinating/PC1.png",
      linkedin: "https://www.linkedin.com/in/rashmila-deshani-784000325",
      email: "rarashmiladeshani@gmail.com",
    },
    {
      id: 19,
      name: "Janani Amarasiri",
      title: "Program Team Member",
      image: "/assets/coordinating/PC2.png",
      linkedin: "http://www.linkedin.com/in/janani-amarasiri-5a2004287",
      email: "jananiamarasiri200011@gmail.com",
    },
    {
      id: 20,
      name: "Amaya Fernando",
      title: "Program Team Member",
      image: "/assets/coordinating/PC3.png",
      linkedin: "https://www.linkedin.com/in/amaya-fernando",
      email: "fdoamaya18@gmail.com",
    },
    {
      id: 21,
      name: "Vindhya Kulasinghe",
      title: "Program Team Member",
      image: "/assets/coordinating/PC4.png",
      linkedin:
        "https://www.linkedin.com/in/vindhya-kumari-kulasinghe-4a828925b",
      email: "vindyakulasinghe24@gmail.com",
    },
    {
      id: 22,
      name: "Gayani Madhubhashini",
      title: "Program Team Member",
      image: "/assets/coordinating/PC5.png",
      linkedin: "https://www.linkedin.com/in/gayani-madhubhashini-995781256",
      email: "gayanimadhubhashini17@gmail.com",
    },
    {
      id: 23,
      name: "Gimhani Jayamanna",
      title: "Program Team Member",
      image: "/assets/coordinating/PC6.png",
      linkedin: "https://www.linkedin.com/in/gimhani-jayamanna-41695a276",
      email: "pabasarajayamanna@gmail.com",
    },
    {
      id: 24,
      name: "Chirani Siriwardhana",
      title: "Membership Team Member",
      image: "/assets/membership/MD1.png",
      linkedin: "https://www.linkedin.com/in/chirani-siriwardhana-55361b299",
      email: "chiranisiriwardana@gmail.com",
    },
    {
      id: 25,
      name: "Agalini Pushparajah",
      title: "Membership Team Member",
      image: "/assets/membership/MD2.png",
      linkedin: "http://linkedin.com/in/agalini-pushparajah-0a9251278",
      email: "agalpush19@gmail.com",
    },
    {
      id: 26,
      name: "Nethmi Senavirathna",
      title: "Membership Team Member",
      image: "/assets/membership/MD3.png",
      linkedin: "http://linkedin.com/in/nethmi-senavirathna-282262241",
      email: "nethmidileka057@gmail.com ",
    },
    {
      id: 27,
      name: "Naduni Wimalarathna",
      title: "Media Team Member",
      image: "/assets/media/MC1.png",
      linkedin: "https://www.linkedin.com/in/savandi-kodithuwakku",
      email: "naduniwimalarathna21@gmail.com",
    },
    {
      id: 28,
      name: "Savandi Kodithuwakku",
      title: "Media Team Member",
      image: "/assets/media/MC2.png",
      linkedin: "https://www.linkedin.com/in/savandi-kodithuwakku",
      email: "kodithuwakkusavandi@gmail.com",
    },
    {
      id: 29,
      name: "Shenali Gamage",
      title: "Media Team Member",
      image: "/assets/media/MC3.png",
      linkedin: "https://www.linkedin.com/in/shenali-gamage",
      email: "ugshenali@gmail.com",
    },
    {
      id: 30,
      name: "Kenuka Karunakaran",
      title: "Media Team Member",
      image: "/assets/media/MC4.png",
      linkedin: "https://www.linkedin.com/in/kenukak",
      email: "kenukaruna08@gmail.com",
    },
    {
      id: 31,
      name: "Piumi Jayodya",
      title: "Media Team Member",
      image: "/assets/media/MC5.png",
      linkedin: "http://www.linkedin.com/in/jayodya98",
      email: "jayodyapiumi@gmail.com",
    },
    {
      id: 32,
      name: "Pipuni Pramoda",
      title: "Media Team Member",
      image: "/assets/media/MC6.png",
      linkedin: "https://www.linkedin.com/in/pipuni-pramoda-59118924a",
      email: "pipunipramoda003@gmail.com",
    },
    {
      id: 33,
      name: "Pasathma Ruwanpathirana",
      title: "Media Team Member",
      image: "/assets/media/MC7.png",
      linkedin: "https://www.linkedin.com/in/pasathma-ruwanpathirana-3375b5308",
      email: "pasathmaruwanpathirana@gmail.com",
    },
  ];

  const getActiveMembers = () => {
    switch (activeTab) {
      case "excom":
        return excomMembers;
      case "bod":
        return bodMembers;
      case "committee-leads":
        return committeeLeads;
      case "committee":
        return committeeMembers;
      default:
        return excomMembers;
    }
  };

  return (
    <section id="team" className="section team">
      <div className="container">
        <h2 className="section-title">Our Team</h2>
        <p className="section-subtitle">
          Meet the incredible team leading IEEE WIE University of Moratuwa
        </p>

        <div className="team-tabs">
          <button
            className={`tab-button ${activeTab === "excom" ? "active" : ""}`}
            onClick={() => setActiveTab("excom")}
          >
            Executive Committee
          </button>
          <button
            className={`tab-button ${activeTab === "bod" ? "active" : ""}`}
            onClick={() => setActiveTab("bod")}
          >
            Board of Directors
          </button>
          <button
            className={`tab-button ${activeTab === "committee-leads" ? "active" : ""}`}
            onClick={() => setActiveTab("committee-leads")}
          >
            Committee Leads
          </button>
          <button
            className={`tab-button ${activeTab === "committee" ? "active" : ""}`}
            onClick={() => setActiveTab("committee")}
          >
            Committee Members
          </button>
        </div>

        <div
          className={`team-grid${activeTab === "excom" ? " excom-grid" : ""}`}
        >
          {getActiveMembers().map((member, index) => (
            <div
              key={member.id}
              className="team-card animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="member-image">
                <img src={member.image} alt={member.name} />
              </div>

              <div className="member-info">
                <h3 className="member-name">{member.name}</h3>
                <p className="member-title">{member.title}</p>
                {((member.linkedin &&
                  member.linkedin !== "#" &&
                  member.linkedin.trim() !== "") ||
                  member.email) && (
                  <div className="social-links">
                    {member.linkedin &&
                      member.linkedin !== "#" &&
                      member.linkedin.trim() !== "" && (
                        <a
                          href={member.linkedin}
                          className="social-link"
                          target="_blank"
                          rel="noopener noreferrer"
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          <FaLinkedin /> LinkedIn
                        </a>
                      )}
                    {member.email && (
                      <a
                        href={`mailto:${member.email}`}
                        className="social-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        <FaEnvelope /> Email
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
